/**
 * get JSON from HTML element on the page
 */
import React, {useEffect, useState} from "react";


export const getJSONFromHtml = ($el: HTMLElement|null) => {
    if(!$el || !$el.textContent) return null;

    let json = null;

    try{
        json = JSON.parse($el.textContent);
    }
    catch(ex){}

    return json;
};

/**
 * get setting fromHTML
 * <div id="...">...</div>
 */
export const getSettingFromHtml = (id: string) => {
    const $div = document.querySelector(`#${ id }`);
    if(!$div || !$div.textContent) return '';
    return $div.textContent.trim();
};

/**
 * helper: get GUID
 */
const guidHelper = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};

/**
 * get GUID
 */
export const guid = () => {
    return guidHelper() + guidHelper() + '-' + guidHelper() + '-' + guidHelper() + '-' + guidHelper() + '-' + guidHelper() + guidHelper() + guidHelper();
};

/**
 * timeout in milliseconds
 */
export const timeout = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

/**
 * get page node GUID from meta tag printed in HTML
 * <div id="nodeguid">67633544-c1c1-4096-a3cc-880a96fe4713</div>
 */
export const getPageNodeGUID = () => {
    const $div = document.querySelector('#nodeguid');
    if(!$div || !$div.textContent) return '';
    return $div.textContent.trim();
};

/**
 * get img CDN domain
 */
export const getImgCDNDomain = () => {
    const $box = document.getElementById('img-cdn-domain');
    const domain = $box?.textContent || '';
    return domain.trim().toLowerCase();
};

declare const window: any;
export const isMobile = () => {
    let check = false;

    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})( navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
export const isTablet_NOTWORK = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    return isTablet;
};
export const isTablet = () => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice && !isMobile()) {
        return true;
    } else {
        return  false;
    }
};

export const stopAllYouTubeVideos = () => {
    // eslint-disable-next-line
    document.querySelectorAll('iframe').forEach(v => { v.src = v.src;});
    const cnt = document.querySelectorAll('iframe')?.length;
    if(cnt > 0){
    window.setTimeout(() => {
        window.history.go(cnt-1);
            }, 200);
    }
    //window.history.go(-1);
}


export const getHashByPrefix = (toFind:string, indexToFind:number = 0) => {
    let result = "";
    const _hash =  window.location.hash.substring(1);
    if(!_hash || _hash === '')
        return result;
    var a = decodeURIComponent(_hash).split("|"),
        i;

    for (i = 0; i < a.length; i++) {

        if(i < indexToFind)
            continue;

        if(a[i].startsWith(toFind) || toFind === ''){
            result = a[i];
            return result;
        }
    }

    return result;
};

export const  getParents = (elem: any) => {

    // Set up a parent array
    var parents = [];

    // Push each parent element to the array
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        parents.push(elem);
    }

    // Return our parent array
    return parents;

};
export const  isChildOfElementById = (elem: any, parentId: string) => {

    let res = false;
    // Push each parent element to the array
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if(elem.id && elem.id === parentId)
            res = true;
    }

    // Return our parent array
    return res;

};
//Hook for dynamic window size
export const  useWindowSize = () => {

    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;

};
//Hook for detect if HTML element is overflow
export const useIsOverflow = (ref : any) => {
    const [isOverflow, setIsOverflow] = React.useState(false);

    React.useLayoutEffect(() => {
        const { current } = ref;

        const trigger = () => {
            const hasOverflow = current.scrollWidth > current.clientWidth;

            setIsOverflow(hasOverflow);

            //if (callback) callback(hasOverflow);
        };

        if (current) {
            trigger();
        }
    }, [ ref]);

    return isOverflow;
};

export const openWindowPopup = (url: string, title: string, width: number, height: number) => {
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);
    return  window.open(
        url,
        title,
        `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${ width }, height=${ height }, top=${ top }, left=${ left }`
    );
};